export const INTERCOM_LAUNCHER_ID = 'custom-intercom-launcher';
